"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChileJourneyParser = void 0;
var _constants = require("../../constants");
var _JourneyParser = require("../generic/JourneyParser");
class ChileJourneyParser extends _JourneyParser.JourneyParser {
  getNameOfJourney() {
    var _this$currentQuestion, _this$currentQuestion2, _this$flags, _this$flags4;
    const questionType = (_this$currentQuestion = this.currentQuestion) === null || _this$currentQuestion === void 0 ? void 0 : (_this$currentQuestion2 = _this$currentQuestion.taggingMetadata) === null || _this$currentQuestion2 === void 0 ? void 0 : _this$currentQuestion2.questionType;
    if (questionType) {
      return questionType.includes(_constants.FLAGS.PLAN) ? this.planJourneyName : this.handsetJourneyName;
    } else if ((_this$flags = this.flags) !== null && _this$flags !== void 0 && _this$flags['both-flow']) {
      var _this$flags2, _this$flags3;
      return (_this$flags2 = this.flags) !== null && _this$flags2 !== void 0 && _this$flags2.plan && !((_this$flags3 = this.flags) !== null && _this$flags3 !== void 0 && _this$flags3.phone) ? this.planJourneyName : this.handsetJourneyName;
    } else if ((_this$flags4 = this.flags) !== null && _this$flags4 !== void 0 && _this$flags4.plan) {
      return this.planJourneyName;
    }
    return this.handsetJourneyName;
  }
}
exports.ChileJourneyParser = ChileJourneyParser;